import React from 'react';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { AsyncTypeahead, Token } from "react-bootstrap-typeahead";
import {
  Badge
} from "reactstrap";
import { search } from "../../store/actions/search";
import { getTags } from "../../store/actions/tags";
import { getAllChannels } from "../../store/actions/channels";
import Img from "../Img";
import "./SearchTypeahead.scss";
import artistString from '../../utils/artistString';
import Track from "../Track";

import {
  tagTypes,
  tagContentTypes
} from "../Channels/constants";
import Typeahead from './Typeahead';

class SearchTypeahead extends React.PureComponent {
  componentWillReceiveProps(nextProps) {
    if (nextProps.searchType !== this.props.searchType && this.props.input.value && this.input) this.input.getInstance().clear();
  }
  componentDidMount() {
    if (this.props.searchType === 'tag' && !this.props.tags.length) this.props.getTags();
    if (this.props.searchType === 'channel' && !Object.keys(this.props.channels).length && !this.props.loadingChannels) {
      this.props.getAllChannels();
    }
  }
  render() {
    const { input, label, searchType, forwardedRef, placeholder, loading = false, getTags, tags, search, searchResult, ...rest } = this.props;
    if (searchType === 'channel' && !Object.keys(this.props.channels).length) return null;
    if (searchType === 'tag') {
      if (tags.length > 0) {
        return (
          <Typeahead
            inputProps={{ id: 'tag-input' }}
            options={tags.filter(tag => !((this.props.selected || input.value || []).map(t => t.id || t).includes(tag.id)))}
            placeholder="جستجو و انتخاب تگ"
            emptyLabel="تگی پیدا نشد"
            multiple
            paginationText="نمایش موارد بیشتر"
            labelKey={item => {
              const tagInfo = tags.filter(tag => tag.id === (item.id || item))[0];
              return (
                `${tagTypes[tagInfo.type]}-${tagInfo.value}${
                tagInfo.contentType ? "(" : ""
                }${tagContentTypes[tagInfo.contentType || "no"]}${
                tagInfo.contentType ? ")" : ""
                }`
              );
            }}
            onChange={selected => {
              input.onChange(selected.map(item => item.id || item))
            }}
            selected={this.props.selected || input.value}
            {...rest}
          />
        )
      }
      return null;
    }
    return (
      <AsyncTypeahead
        ref={node => {
          this.input = node;
          if (typeof forwardedRef === 'function') forwardedRef(node);
        }}
        labelKey={item => (((item.name || item.artisticName || (item.firstName + ' ' + item.lastName)) + (item.mobileNumber ? '-' : '', item.mobileNumber || '', item.email ? '-' : '', item.email || '') || item.entityId) || item).toString()}
        filterBy={option =>
          option.name ||
          option.artisticName ||
          option.email ||
          option.mobileNumber ||
          option.value ||
          option.key
        }
        align="justify"
        promptText="برای جستجو شروع به نوشتن کنید"
        placeholder={(placeholder && placeholder.toString()) || `جستجو و انتخاب ${label}`}
        emptyLabel={`${label}${label ? 'ی' : ''} پیدا نشد`}
        searchText={`در حال جستجو${label ? 'ی' : ''} ${label}`}
        clearButton
        useCache={false}
        isLoading={loading}
        onSearch={query => {
          search({ type: searchType, text: query, size: 50 });
        }}
        onChange={selected => {
          input.onChange(selected)
        }}
        options={
          !loading ?
            searchResult[`${searchType}s`]
            : []
        }
        renderToken={
          (option, props, index) => {
            return (
              <Token
                key={index}
                onRemove={props.onRemove}>
                {Object.values(option).length ? ((option.name || option.artisticName || (option.firstName + ' ' + option.lastName)).concat(option.mobileNumber ? '-' : '', option.mobileNumber || '', option.email ? '-' : '', option.email || '') || option.entityId) : option}
              </Token>
            );
          }
        }
        renderMenuItemChildren={result => {
          if (searchType === 'track') return <Track data={result} />
          return (
            <div className="text-right">
              {(result.image || result.primaryImage || result.picture) && (
                <Img className="ml-3 rounded" src={(result.image || result.primaryImage || result.picture).replace('https://', '//').replace('http://', '')} width="40" height="40" />
              )
              }
              {result.name || result.artisticName}
              {result.firstName}
              {result.firstName && ' '}
              {result.lastName}
              {(result.firstName || result.lastName) && `-`}
              {result.email}
              {result.email && result.mobileNumber && `-`}
              {result.mobileNumber}
              {result.artists && artistString(result.artists)}
              {result.firstArtists &&
                result.firstArtists.length > 0 &&
                result.firstArtists.map((artist, index) => (
                  <small className="mr-3" key={index}>
                    {artist.artisticName}
                  </small>
                ))
              }
              {result.durationMin &&
                <Badge className="mr-3">
                  {result.durationMin}:{result.durationSec}
                </Badge>
              }
            </div>
          )
        }}
        selected={searchType !== 'channel' ? this.props.selected || input.value || [] : (this.props.selected || input.value || []).map(ch => (this.props.channels[ch.id || ch] || ch))}
        {...rest}
      />
    )
  }
}

const ConnectedSearchTypeahead = connect(
  state => (
    {
      searchResult: state.search,
      loading: state.loading.search,
      loadingChannels: state.loading.channels,
      tags: state.tags,
      channels: state.channels
    }
  ),
  dispatch => bindActionCreators({
    search,
    getTags,
    getAllChannels
  }, dispatch)
)(SearchTypeahead)

export default React.forwardRef((props, ref) => <ConnectedSearchTypeahead {...props} forwardedRef={ref} />)